import { useGetCities } from '@entities/region';
import { Loader, Select, type SelectProps } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';

export const RegionsSelect = ({ ...props }: SelectProps) => {
  const { data, isLoading } = useGetCities();

  return (
    <Select
      data={data?.map(item => ({
        label: item.name,
        value: item.id.toString(),
      }))}
      rightSection={
        isLoading ? (
          <Loader size='xs' />
        ) : (
          <IconChevronDown size={20} color='var(--mantine-color-primary-7)' />
        )
      }
      searchable
      {...props}
    />
  );
};
